import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_CONTRACT';

export async function createContract(
    userToken: string,
    newContract: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/contracts/`,
            data: newContract,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la création d\' un contrat',
            error: error
        });
    }
}
